import { z } from 'zod';

export enum ProgrammaticDealsSearchKey {
  SEARCH = 'searchFilter',
}

export const programmaticDealsRouterSearchParamsSchema = z.object({
  [ProgrammaticDealsSearchKey.SEARCH]: z.string().optional(),
});
